<template>
  <am-card v-on="$listeners" v-bind="$attrs">
    <am-card-body>
      <div class="am-placeholder-header am-placeholder-loading" v-if="header"></div>
      <div class="am-placeholder-rows">
        <div v-for="row in rows" :key="row" class="am-placeholder-row am-placeholder-loading"></div>
      </div>
    </am-card-body>
  </am-card>
</template>

<script>
import { AmCard, AmCardBody } from "../Card";

export default {
  inheritAttrs: false,
  components: {
    AmCard,
    AmCardBody
  },
  props: {
    /**
     * Show placeholder header
     */
    header: {
      type: Boolean,
      default: true
    },
    /**
     * Number of placeholder rows
     */
    rows: {
      type: Number,
      default: 3
    }
  },
  computed: {
    classes() {
      return ["am-placeholder"];
    }
  }
};
</script>
